<template>
  <div class="life-user flex_column">
    <div class="life-user-box flex_column">
      <!-- <div class="flex_row_top">
        <div class="life-user-logo">
          <img :src="userInfo.img_url ? userInfo.img_url: '/static/images/lifePay/default_logo.png'" />
        </div>
        <div class="life-user-name">
          HI, {{userInfo.wx_name ? userInfo.wx_name: '游客'}}
        </div>
      </div> -->
      <div class="life-user-tips">
        <!-- <div class="life-tips-title">温馨提醒</div>
        <div class="life-tips-content">
          Meraclo电费缴费，在晚上19:00至上午7:00期间下单会有延迟哦！如有疑问，可留言给人工客服。
        </div> -->
        <MySwiper :swipers="swiperList" :indicatorDots="false" radius="9px" />
      </div>
    </div>
    <img src="../../static/images/lifePay/life_yh.png"
    class="life-user-yuanhu" />
    <img src="../../static/images/lifePay/life_logo.png"
    class="user-bg" />
  </div>
</template>

<script>
  import MySwiper from '@/components/swiper.vue';

  export default {
    props: {
      swiperList: {
    	  type: Array,
    	  default: () => []
      }
    },
    components: {
      MySwiper
    },
    data() {
      return {
        userInfo: {}
      }
    },
    created() {
      this.initUser()
    },
    methods: {
      async getUserInfo() {
        const { data } = await this.$api.request('Member/getInfo', {})
        this.userInfo = data
      },
      initUser() {
        const auth_token = localStorage.getItem('auth_token');
        if (!auth_token) return
        this.getUserInfo();
      }
    }
  }
</script>

<style lang="less" scoped>
  .life-user-yuanhu {
    width: 100%;
    height: auto;
  }
  .life-user {
    width: 100%;
    min-height: 273px;
    position: relative;
    overflow: hidden;

    .life-user-box {
      width: 100%;
      height: auto;
      // position: relative;
      // z-index: 9;
      // padding: 43px 22px 48px 26px;
      padding: 43px 22px 0 26px;
      // overflow: hidden;
      background-color: #fff;

      .life-user-tips {
        // height: 147px;
        width: 100%;
        margin-top: 23px;
        position: relative;
        z-index: 99;
        // min-height: 147px;
        // background: linear-gradient(185.92deg, #FF424A, #7B060B);
        // border-radius: 8px;

        // padding: 13px 7px 20px 7px;

        // .life-tips-title {
        //   font-size: 22px;
        //   line-height: 26px;
        //   font-weight: 700;
        //   color: #FFFFFF;
        //   letter-spacing: 0.5px;
        // }

        // .life-tips-content {
        //   font-size: 16px;
        //   line-height: 24px;
        //   font-weight: 500;
        //   color: #FFFFFF;
        //   margin-top: 18px;
        //   text-align: left;
        // }
      }

      .life-user-logo {
        width: 60px;
        height: 60px;
        background-color: #F4F3F3;
        border-radius: 7px;
        overflow: hidden;
        margin-right: 15px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .life-user-name {
        color: #000;
        font-family: Roboto;
        font-size: 18px;
        line-height: 21px;
        font-weight: 600;
        // letter-spacing: 0%;
        text-align: left;
        margin-top: 9px;
      }
    }

    .user-bg {
      position: absolute;
      width: 62%;
      height: auto;
      right: -12%;
      // top: -23.5%;
      top: 0;
      transform: translateY(-24.6%);
      // transform: rotate(5deg);
      z-index: 12;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/lifeUser.vue